// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__DGsDg","text":"style_text__15IuH","articleOrder":"style_articleOrder__8zzSB","articleTitle":"style_articleTitle__QG5a2"};